const svgCache = new Map<
  string,
  HTMLElement | SVGSVGElement | Error | undefined
>()

export default svgCache
